import { BaseComponent, cssHelper } from "react-vextensions";
import React from "react";
export class InTooltip extends BaseComponent {
    render() {
        const { style, children, ...rest } = this.props;
        const { css } = cssHelper(this);
        return (React.createElement("div", { ...rest, style: css({ whiteSpace: "pre-wrap" }, style) }, children));
    }
}
//# sourceMappingURL=Tooltip.js.map